import R from 'ramda';
import { triggerError } from '../stores/global-errors-display/global-errors-display-actions';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
export const triggerNoAccessWarning = additionalPayload => triggerError({ noAccessDialog: true, ...additionalPayload });


export const getFeatureAccess = (state, locId, featureName) => {
  const { user } = state;
  const locAccess = user.toJS ? user.toJS().locAccess : user.locAccess;
  const companyType = user.toJS ? user.toJS().user.type : user.user.type;
  const email = user.toJS ? user.toJS().user.email : user.user.email;
  const corporateContractingAccess = user.toJS ? user.toJS().corporateContractingAccess : user.corporateContractingAccess;
  const corporateAdminAccess = user.toJS ? user.toJS().corporateAdminAccess : user.corporateAdminAccess;
  if (locId && companyType === 'Supplier' && email.indexOf('dl+') === -1) {
    const accessForLoc = R.find(R.propEq('locId', locId), locAccess);
    return R.propOr([], featureName, accessForLoc);
  }
  if (featureName === 'contracting') return R.chain(R.prop(featureName), locAccess).concat(corporateContractingAccess);
  if (featureName === 'admin') return R.chain(R.prop('admin'), locAccess).concat(corporateAdminAccess);
  return R.chain(R.prop(featureName), locAccess);
};

export const checkLocAccess = (state, locId, featureName, access) => {
  const featureAccess = getFeatureAccess(state, locId, featureName);
  return featureAccess && R.contains(access, featureAccess);
};

// export const checkCorporateAccess = (state, featureName, access) => {
//   const { user } = state;
//   const corporateAccess = user.toJS ? user.toJS().corporateAccess : user.corporateAccess;
//   return corporateAccess[featureName] && R.contains(access, corporateAccess[featureName]);
// };

export const checkCorporateAccess = (state) => {
  const { user } = state;
  const corporateAccess = user.toJS ? user.toJS().corporateAccess : user.corporateAccess;
  return !isNilOrEmpty(corporateAccess);
};




// WEBPACK FOOTER //
// ./src/app/middleware/accessCheckHelperFns.js